import { SvgIcon, SvgIconProps } from "@mui/material";

export default function ProductIcon(props: SvgIconProps) {
    return (
        <SvgIcon
            viewBox="0 0 64 64"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            {...props}
        >
            {/* Basket */}
            <path fill="none" d="M12 30 H52 L48 52 H16 Z" />
            <line x1="20" y1="30" x2="26" y2="18" />
            <line x1="44" y1="30" x2="38" y2="18" />
            <line x1="24" y1="38" x2="24" y2="48" />
            <line x1="32" y1="38" x2="32" y2="48" />
            <line x1="40" y1="38" x2="40" y2="48" />

            {/* Leaf */}
            <path
                fill="none"
                d="M30 22 C28 16, 36 14, 38 18 C40 22, 34 24, 30 22 Z"
            />
            <line x1="34" y1="22" x2="34" y2="16" />
        </SvgIcon>
    );
}
